<template>
  <div class="main-layout w-full flex" :class="layoutClass">
    <MainMenu />

    <div
      class="main-layout-content h-full w-full flex flex-col"
      :class="contentClass"
    >
      <MainHeader />

      <slot />
    </div>
  </div>
</template>

<script>
  import MainMenu from '@/components/layouts/main/menu';
  import MainHeader from '@/components/layouts/main/header';

  export default {
    name: 'MainLayout',

    components: {
      MainMenu,
      MainHeader,
    },

    data() {
      return {
        hasScrollbar: false,
      };
    },

    computed: {
      layoutClass() {
        return {
          'h-full': !this.hasScrollbar,
          'items-stretch': this.hasScrollbar,
        };
      },
      contentClass() {
        return this.$route.meta.contentClass || '';
      },
    },

    watch: {
      $route() {
        this.hasScrollbar = false;

        this.removeScrollEvent();
        this.bindScrollEvent();
      },
    },

    created() {
      this.removeScrollEvent();
      this.bindScrollEvent();
    },

    methods: {
      bindScrollEvent() {
        window.addEventListener('scroll', this.updateScrollbarFlag);
      },

      removeScrollEvent() {
        window.removeEventListener('scroll', this.updateScrollbarFlag);
      },

      updateScrollbarFlag() {
        this.hasScrollbar = true;
        this.removeScrollEvent();
      },
    },
  };
</script>
